angular.module('TeacherControllers', [
  'angular.filter',
])

  //config for routes
  .config(['$routeProvider', function($routeProvider) {
    $routeProvider

      .when('/t/students', {
        templateUrl: '/ng1/www/modules/teacher/students/html/home.html',
        controller: 'TeacherStudentsHomeCtrl'
      })

      .when('/t/exam', {
        templateUrl: '/ng1/www/modules/teacher/exam/html/home.html',
        controller: 'TeacherExamHomeCtrl'
      })

      .when('/t/bright', {
        templateUrl: '/ng1/www/modules/teacher/bright/html/home.html',
        controller: 'TeacherExamBrightCtrl'
      })


      .when('/t/spheres', {
        templateUrl: '/ng1/www/modules/teacher/spheres/html/home.html',
        controller: 'TeacherSpheresHomeCtrl'
      })

      .when('/t/correction', {
        templateUrl: '/ng1/www/modules/teacher/delf/html/corriges.html',
        controller: 'TeacherCorrectionCtrl',
      })

      .when('/correction', {
        templateUrl: '/ng1/www/modules/teacher/delf/html/corriges.html',
        controller: 'TeacherCorrectionCtrl',
      });

  }
  ]);
